/** 음식점 포트폴리오 스크린샷 — public/portfolio/restaurant/ */

function restaurantSrc(filename) {
  return `/portfolio/restaurant/${filename}`;
}

function restaurantItem(id, title, filename, url) {
  return { id, title, url, src: restaurantSrc(filename) };
}

export const RESTAURANT_PORTFOLIO_IMAGES = [
  restaurantItem("atelier-yuga", "아틀리에 유가", "restaurant-2.webp", "atelier-yuga.dsite"),
  restaurantItem("maison-de-gout", "메종 드 구", "pasta.webp", "maison-de-gout.dsite"),
  restaurantItem("azzurro", "아주로 씨푸드 바", "seafood.webp", "azzurro-seafood.dsite"),
  restaurantItem("sushi-wave", "스시웨이브", "sushi.webp", "sushi-wave.dsite"),
  restaurantItem("hanu-maeum", "한우마음", "hanu-house.webp", "hanu-maeum.dsite"),
  restaurantItem("mad-for-pasta", "매드포파스타", "pasta-2.webp", "mad-for-pasta.dsite"),
  restaurantItem("bollywood-curry", "볼리우드 커리하우스", "curry-house.webp", "bollywood-curry.dsite"),
  restaurantItem("tonkotsu-ramen", "돈코츠 라멘 바", "ramen-house.webp", "tonkotsu-ramen.dsite"),
  restaurantItem("slow-bowl", "슬로우볼", "salad.webp", "slow-bowl.dsite"),
];

export const DEFAULT_RESTAURANT_IMAGE = RESTAURANT_PORTFOLIO_IMAGES[0];
